import React from 'react';
import { Navbar } from '../components/Navbar';
import { StickyFooter } from '../components/StickyFooter';
import { ServiceHero } from '../components/ServiceHero';
import { ServiceContactForm } from '../components/ServiceContactForm';
import { CheckCircleIcon } from 'lucide-react';
export function RegisteredPracticalNurses() {
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-1185">
      <Navbar data-id="element-1186" />
      <main className="flex-1" data-id="element-1187">
        <ServiceHero badge="Services" title="Registered Practical Nurses (RPN)" subtitle="Skilled clinical support, medication management, and direct patient care." imageUrl="https://images.unsplash.com/photo-1631815589968-fdb09a223b1e?w=1600&auto=format&fit=crop" data-id="element-1188" />

        <div className="max-w-4xl mx-auto px-4 py-16 lg:py-24" data-id="element-1189">
          <div className="prose prose-lg max-w-none text-text-muted leading-relaxed space-y-6" data-id="element-1190">
            <p data-id="element-1191">
              Our Registered Practical Nurses (RPNs) provide vital clinical
              support and direct patient care. They are trained to administer
              medications, perform assessments, and assist with complex care
              needs under the guidance of a Registered Nurse or physician.
            </p>
            <p data-id="element-1192">
              We connect facilities with experienced RPNs who are fully vetted,
              licensed, and ready to step into any healthcare setting. From
              long-term care facilities to community health centers, our RPNs
              deliver high-quality, compassionate care.
            </p>
          </div>

          <div className="mt-12 bg-gray-50 rounded-2xl p-8 border border-gray-100" data-id="element-1193">
            <h3 className="text-2xl font-bold text-text-dark mb-6" data-id="element-1194">
              RPN Services Include
            </h3>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1195">
              {['Medication administration & management', 'Comprehensive patient assessments', 'Wound care & specialized treatments', 'Collaboration with RNs and physicians', 'Long-term care & community health expertise', 'Fully licensed and clinically vetted'].map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-1196">
                  <CheckCircleIcon className="w-6 h-6 text-accent-teal flex-shrink-0 mt-0.5" data-id="element-1197" />
                  <span className="text-text-dark font-medium" data-id="element-1198">{feature}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <ServiceContactForm serviceName="Registered Practical Nurses (RPN)" data-id="element-1199" />
      </main>
      <StickyFooter data-id="element-1200" />
    </div>;
}